<!-- 版本回退 -->
<template>
  <div>
    <div v-if="!selectedApp">
      <div style="margin-bottom: 20px;">
        <el-input
          v-model="pageInfo.keyword"
          style="width:200px;margin-right: 10px;"
          placeholder="请输入小程序名称/appid"
        />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="app_id" label="小程序appid" width="200" align="center" />
        <el-table-column prop="account_name" label="小程序名称" align="center" />
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="selectApp(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <div v-else v-loading="historyLoading">
      <div style="margin-bottom: 16px;">
        <span>当前小程序：</span>
        <span>{{ selectedApp.account_name }} / {{ selectedApp.app_id }}</span>
        <el-button type="text" style="margin-left: 12px;" @click="backToSelect">重新选择</el-button>
      </div>
      <div v-if="historyList.length === 0 && !historyLoading" class="empty-tip">暂无历史版本</div>
      <el-table
        v-else
        ref="historyTable"
        :data="historyList"
        border
        style="width: 100%"
        highlight-current-row
        class="history-version-table"
        @row-click="handleRowClick"
      >
        <el-table-column prop="user_version" label="版本号" align="center" width="120" />
        <el-table-column prop="user_desc" label="版本描述" align="center" show-overflow-tooltip />
        <el-table-column label="提交时间" align="center" width="180">
          <template slot-scope="scope">
            {{ formatCommitTime(scope.row.commit_time) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :loading="revertLoading"
              @click.stop="revertToRow(scope.row)"
            >回退到此版本</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: center;">
        <el-button
          type="warning"
          :disabled="historyList.length < 2"
          :loading="revertLoading"
          @click="revertToPrevious"
        >回退到上一个版本</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { appletlistrw, getHistoryVersion, revertCodeRelease } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      pageInfo: {
        page: 1,
        page_size: 10,
        keyword: ''
      },
      tableData: [],
      total: null,
      selectedApp: null,
      historyList: [],
      historyLoading: false,
      selectedVersion: null,
      revertLoading: false
    }
  },
  methods: {
    init() {
      this.selectedApp = null
      this.historyList = []
      this.selectedVersion = null
      this.pageInfo.page = 1
      this.getprogramlist()
    },
    async getprogramlist() {
      const data = await appletlistrw(this.pageInfo)
      this.tableData = data.data.list
      this.total = data.data.total
    },
    fetchPageSize(e) {
      this.pageInfo.page_size = e
      this.getprogramlist()
    },
    fetchCurrentPage(e) {
      this.pageInfo.page = e
      this.getprogramlist()
    },
    search() {
      this.pageInfo.page = 1
      this.getprogramlist()
    },
    reset() {
      this.pageInfo.page = 1
      this.pageInfo.keyword = ''
      this.getprogramlist()
    },
    selectApp(row) {
      this.selectedApp = row
      this.selectedVersion = null
      this.loadHistory()
    },
    backToSelect() {
      this.selectedApp = null
      this.historyList = []
      this.selectedVersion = null
    },
    formatCommitTime(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      const pad = (n) => (n < 10 ? '0' + n : n)
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    getVersionLabel(appVersion) {
      const row = this.historyList.find((item) => item.app_version === appVersion)
      return row ? row.user_version : appVersion
    },
    async loadHistory() {
      if (!this.selectedApp) return
      this.historyLoading = true
      try {
        const res = await getHistoryVersion({
          app_id: this.selectedApp.app_id
        })
        const versionList = (res.data && res.data.version_list) ? res.data.version_list : []
        // const mockList = [
        //   {
        //     app_version: 'mock_version_001',
        //     user_version: '1.2.0',
        //     user_desc: '模拟数据-当前版本',
        //     commit_time: Math.floor(Date.now() / 1000)
        //   },
        //   {
        //     app_version: 'mock_version_002',
        //     user_version: '1.1.0',
        //     user_desc: '模拟数据-上一版本',
        //     commit_time: Math.floor(Date.now() / 1000) - 86400
        //   }
        // ]
        this.historyList = versionList
      } finally {
        this.historyLoading = false
      }
    },
    handleRowClick(row) {
      this.selectedVersion = row.app_version
      this.$refs.historyTable.setCurrentRow(row)
    },
    revertToPrevious() {
      if (this.historyList.length < 2) {
        this.$message.warning('没有可回退的上一个版本')
        return
      }
      const prev = this.historyList[1]
      this.doRevert('', `上一个版本 ${prev.user_version}`)
    },
    revertToSelected() {
      if (this.selectedVersion == null) {
        this.$message.error('请选择要回退的历史版本')
        return
      }
      this.doRevert(this.selectedVersion, `所选版本 ${this.getVersionLabel(this.selectedVersion)}`)
    },
    revertToRow(row) {
      this.doRevert(row.app_version, `版本 ${row.user_version}`)
    },
    doRevert(appVersion, label) {
      this.$confirm(
        '您确定要回退吗?回退只有一次机会，<br/>回退后不能继续回退到之前的版本，只能新发布代码更新',
        '提醒',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }
      ).then(async() => {
        this.revertLoading = true
        try {
          const params = { app_id: this.selectedApp.app_id, app_version: appVersion }
          await revertCodeRelease(params)
          this.$message.success('版本回退成功')
          this.$emit('success')
        } finally {
          this.revertLoading = false
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.empty-tip {
  text-align: center;
  padding: 40px 0;
  color: #9a9a9a;
  font-size: 14px;
}

</style>
